import styled, { type FlattenSimpleInterpolation } from 'styled-components'
import Text from '@bufferapp/ui/Text'

import {
  blue,
  gray,
  grayLight,
  grayDark,
  grayDarker,
  redLighter,
  redDark,
} from '@bufferapp/ui/style/colors'

import { fadeIn } from '~/shared/styles/animations'
import { lila } from '~/shared/styles/colors'
import { flexCol, flexRow } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

type StyledProps = {
  selected?: boolean
  error?: boolean
  disabled?: boolean
  animated?: boolean
  expand?: boolean
  overlay?: boolean
}

function getBorderColor(props: StyledProps): string {
  if (props.selected) return blue
  if (props.error) return redLighter
  return grayLight
}

function getBackgroundColor(props: StyledProps): string {
  if (props.disabled) return grayLight
  if (props.selected) return lila
  return 'transparent'
}

/**
 *
 */

export const Wrapper = styled.div`
  ${flexCol}
  width: 100%;
  border-radius: 12px;
  margin-bottom: 8px;
  border: 1px solid ${(props: StyledProps): string => getBorderColor(props)};
  background-color: ${(props: StyledProps): string =>
    getBackgroundColor(props)};
  box-shadow: ${(props: StyledProps): string =>
    props.selected ? '0px 3px 4px rgba(0, 0, 0, 0.2)' : 'none'};
  cursor: ${(props: StyledProps): string =>
    props.selected || props.disabled ? 'default' : 'pointer'};
`

export const CommentWrapper = styled.div`
  ${flexRow}
  align-items: flex-start;
  width: 100%;
  padding: 8px;
  ${(props: StyledProps): FlattenSimpleInterpolation | null =>
    props.animated ? fadeIn : null}
`

export const ErrorWrapper = styled.div`
  ${flexRow}
  align-items: center;
  background-color: ${redLighter};
  width: 100%;
  padding: 8px;
  border-radius: 0px 0px 10px 10px;
  color: ${grayDarker};
`

export const ErrorIconWrapper = styled.div`
  ${flexRow}
  align-items: center;
  color: ${redDark};
  margin-right: 4px;
`

export const ErrorCTA = styled.a`
  color: ${redDark};
  text-decoration: none;
  margin: 0px 4px;
`

export const Column = styled.div`
  ${flexCol}
  align-items: flex-start;
  position: relative;
  ${(props: StyledProps): string => (props.expand ? 'flex: 1;' : '')}
`

export const AvatarWrapper = styled.div`
  width: 32px;
  height: 32px;
  margin-right: 8px;
`

export const ContentWrapper = styled(Column)`
  width: 100%;
  padding-right: 24px;
  white-space: pre-line;
`

export const RepliesWrapper = styled.div`
  padding-left: 48px;
  width: 100%;
`

export const Row = styled.div`
  width: 100%;
`

export const ComposerWrapper = styled.div`
  width: 100%;
  margin-top: 8px;
`

export const Username = styled.span`
  ${baseFont}
  font-weight: bold;
  margin-right: 8px;
  color: ${grayDarker};

  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`

export const CommentInfo = styled.div`
  ${flexRow}
  ${baseFont}
  color: ${grayDark};
  margin: 8px 0px;

  & > * {
    margin-right: 8px;
  }
`

export const TimeAgo = styled.p`
  ${baseFont}
  font-size: 12px;
  font-weight: normal;
`

export const Status = styled.p`
  ${baseFont}
  font-size: 12px;
  font-weight: 500;
  user-select: none;
`

export const Labels = styled.div`
  ${flexRow}

  & > div {
    margin-right: 4px;
  }
`

export const ShowReplies = styled.button`
  ${baseFont}
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  color: ${grayDark};
  text-align: left;
  cursor: pointer;
  background-color: transparent;
  border: none;
  ${(props: StyledProps): string =>
    props.overlay
      ? `
    position: absolute;
    left: -20px;
    bottom: 8px;
  `
      : ''}
`

export const ShowRepliesDecoration = styled.span`
  color: ${gray};
  margin-right: 8px;
  letter-spacing: -2px;
  font-weight: 100;
`

export const ToggleWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
`

export const StyledText = styled(Text)`
  word-break: break-word;
`
